import type { IconData } from '@stacksjs/iconify-core'

export const emailMailboxOpen: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 9.14H32v12.19h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M16.76 21.33V9.14h-1.52V7.62h6.09v4.57h1.52V7.62h6.1V6.1h-6.1V4.57h4.58V0h-6.1v6.1H7.62v1.52H6.09v1.52H4.57v12.19H3.05v1.53h10.66v1.52h1.53V32h1.52v-9.14h4.57V32h1.52v-9.14h7.62v-1.53Zm6.09-19.81h3.05v1.53h-3.05Zm-7.61 16.77h-1.53v1.52h1.53v1.52H7.62v-9.14h7.62Z\"/><path fill=\"currentColor\" d=\"M12.19 16.76h1.52v1.53h-1.52Zm-1.52 7.62h3.04v1.52h-3.04Zm0-9.14v-1.53H9.14v1.53h1.52v1.52h1.53v-1.52zM9.14 25.9h1.53v1.53H9.14Zm-7.62 1.53h7.62v1.52H1.52Zm0-4.57h1.53v1.52H1.52ZM0 24.38h1.52v3.05H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default emailMailboxOpen
